var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62115 0.574918C2.818 0.378368 3.05437 0.225896 3.3146 0.127607C3.57483 0.0293176 3.85298 -0.0125448 4.13061 0.00479393C4.40824 0.0221327 4.67902 0.0982766 4.925 0.22818C5.17098 0.358083 5.38654 0.538779 5.5574 0.758293L7.57678 3.35254C7.9469 3.82842 8.07741 4.44829 7.93116 5.03329L7.31578 7.49704C7.28419 7.62466 7.28601 7.75827 7.32109 7.88498C7.35617 8.01169 7.42331 8.12721 7.51603 8.22042L10.2802 10.9845C10.3735 11.0775 10.4892 11.1447 10.6161 11.1798C10.743 11.2149 10.8769 11.2166 11.0047 11.1848L13.4673 10.5694C13.756 10.4977 14.0572 10.4923 14.3483 10.5536C14.6394 10.615 14.9129 10.7416 15.148 10.9238L17.7423 12.942C18.6749 13.6677 18.7604 15.0458 17.9257 15.8794L16.7624 17.0427C15.9299 17.8752 14.6857 18.2408 13.5258 17.8324C10.5565 16.7891 7.86089 15.0894 5.63953 12.8599C3.4102 10.6389 1.71053 7.94364 0.66703 4.97479C0.25978 3.81604 0.625405 2.57067 1.4579 1.73817L2.62115 0.574918Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFilled);
export default __webpack_public_path__ + "static/media/phone-filled.458c7f0f3cf891d5b675f76a2d3b0e4d.svg";
export { ForwardRef as ReactComponent };